import React, { useMemo } from 'react';

import { AFFILIATE_TEXT_MIDDLE } from '../../constants/AffiliatePageText';

import AffiliateDetail from './AffiliateDetail';


function AffiliatePageMiddle(props) {

  const renderAffiliateDetails = useMemo(() => AFFILIATE_TEXT_MIDDLE.map((detail) => (
    <AffiliateDetail
      key={detail.title}
      desc={detail.desc}
      image={detail.image}
      title={detail.title}
    />
  )), []);

  return (
    <div className="affiliate container white-bg">
      <div className="flex flex-col justify-center items-center content">
        <h1 className="title-large text-center">
          ABOUT OUR PROGRAM
        </h1>
        <div className="flex justify-evenly align-center details">
          {renderAffiliateDetails}
        </div>
        <a className="btn full-width" href={props.affiliateURL}>SIGN UP NOW!</a>
      </div>
    </div>
  );
}

export default AffiliatePageMiddle;
